<template>
  <div class="callme_total_wrap hidden-xs-only">
    <!-- <div class="callme_top_wrap"></div> -->
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <!-- 添加公司logo区域 -->
        <div class="logo_wrap">
          <img src="../../assets/img/hly/new2/btttom-logo.png" alt="logo" class="company-logo" />
        </div>
        <div class="items_wrap">
          <div class="item_tit">{{ $t('callMeBottom.item2') }}</div>
          <div class="item_options">
            <el-menu
              :default-active="activeIndex"
              class="el_menu_demo"
              mode="horizontal"
              background-color="#21282D"
              text-color="#8F9095"
              active-text-color="#8F9095"
              @select="handleSelect"
            >
            </el-menu>
            <div class="massage_show">
              <p>{{ $t('callMeBottom.item2_2') }}</p>
              <p>{{ $t('callMeBottom.item2_3') }}</p>
              <p>{{ $t('callMeBottom.item2_4') }}</p>
              <p> 沪ICP备2025135305号</p>

            </div>
          </div>
        </div>
        <!-- 暂时不需要首页底部二维码 -->
        <div class="items_wrap" >
          <div class="item_tit">{{ $t('callMeBottom.item4') }}</div>
          <div class="item_options">
            <img src="../../assets/img/carbon/hly-qrcode.png" alt="微信二维码" class="qrcode-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      cityInfomation: [
        {
          phone: '15800921098',
          eamil: 'info@hongly-sh.com',
          address: '上海市嘉定区环城路2222号1幢J',
        }
      ],
      showCity: 0,
    }
  },
  methods: {
    handleSelect(index) {
      this.showCity = parseInt(index) - 1
    },
    handleToRouter(url) {
      this.$router.replace(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  margin-top: 80px;
  .callme_top_wrap {
    width: 100%;
    height: 300px;
    background: url('../../assets/img/call.a455486.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .callme_bottom_wrap {
    width: 100%;
    background: #101233;
    color: #fff;
    padding-top: 70px;
          .bottom_container {
        width: 70%;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start; // 改回左对齐，保持原有布局
        align-items: flex-start; // 顶部对齐
        padding-bottom: 60px;
        border-bottom: solid #363636 2px;
        
        // 添加logo样式
        .logo_wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 180px;
          margin-top: 60px; // 增加往下移的距离，与关注我们的图片对齐
          
          .company-logo {
            width: 120px;
            height: auto;
            background-color: #fff;
          }
        }
      
      .items_wrap {
        margin-right: 150px; // 进一步增加右边距，整体往右移
        .item_tit {
          font-size: 26px;
        }
        .item_options {
          display: flex;
          flex-direction: column;
          // width: 120px;
          span {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 16px;
            margin-top: 35px;
            cursor: pointer;
            &:hover {
              font-weight: bold;
            }
          }
          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 10px;
            width: 160px;
            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 18px;
            width: 300PX;
            height: 80px;
            margin-bottom: 120px;
            p {
              margin-top: 10px;
            }
          }
          img {
            width: 100%;
            margin-top: 20px;
          }
        }
      }
    }
    .navigate_wrap {
      width: 70%;
      margin: 0 auto;
      margin-top: 40px;
      padding-bottom: 15px;
      // word-break: keep-all;
      // word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        margin-right: 33px;
        text-decoration: none;
      }
      span {
        color: #fff;
        padding-right: 30px;
        font-size: 18px;
        margin-right: 0;
      }
      p {
        font-size: 16px;
        color: #4e5557;
      }
    }
  }
}
</style>